module.exports = __webpack_public_path__ + "img/page-not-enabled.b0d1f253.svg";